document.addEventListener("DOMContentLoaded", function () {
  let flkty; // Store the Flickity instance here
  
  function waitForProductRecommendations() {
    const relatedProductsSection = document.querySelector("product-recommendations");

    if (relatedProductsSection) {
      console.log('product-recommendations found!');
      watchForGridItems(relatedProductsSection);
    } else {
      console.log('product-recommendations not found yet, retrying...');
      setTimeout(waitForProductRecommendations, 100); // Adjust delay as needed
    }
  }

  function initializeCarousel(carouselGrid) {
    const gridItems = carouselGrid.querySelectorAll(".grid__item");
    console.log('Found grid items:', gridItems.length);

    // Adjust initialization based on screen size
    const isMobile = window.matchMedia("(max-width: 989px)").matches;
    if (isMobile && gridItems.length > 1 || !isMobile && gridItems.length > 4) {
      console.log('Initializing carousel with Flickity');

      // Set up Flickity options based on screen width
      const options = getCarouselOptions();

      // Initialize Flickity carousel
      flkty = new Flickity(carouselGrid, options);

      
      // Add a throttled listener to update the carousel on resize
      window.addEventListener("resize", throttle(handleResize, 200));

       // Reinitialize Yotpo after carousel is initialized
      /*if (typeof window.yotpo !== 'undefined' && typeof window.yotpo.refreshWidgets === 'function') {
        console.log('Refreshing Yotpo widgets');
        window.yotpo.refreshWidgets();
      } else {
        // If Yotpo hasn't loaded yet, try again in a bit
        console.log('Yotpo not found, trying again in 1 second');
        setTimeout(function() {
          if (typeof window.yotpo !== 'undefined' && typeof window.yotpo.refreshWidgets === 'function') {
            console.log('Refreshing Yotpo widgets (delayed)');
            window.yotpo.refreshWidgets();
          } else {
            console.log('Yotpo still not available after delay');
          }
        }, 1000);
      }*/
      
    } else {
      console.log('Not enough grid items to initialize carousel.');
    }
  }

  function handleResize() {
    const carouselGrid = document.querySelector("product-recommendations .product-grid");
    if (!carouselGrid) return;

    const newOptions = getCarouselOptions();

    // Check if `groupCells` needs updating
    if (newOptions.groupCells !== flkty.options.groupCells || newOptions.contain !== flkty.options.contain) {
      flkty.destroy(); // Destroy current instance
      initializeCarousel(carouselGrid); // Reinitialize with updated options
 //     alert('MC');
    }
  }

  function getCarouselOptions() {
    // Adjust settings based on the viewport width
    const isMobile = window.matchMedia("(max-width: 989px)").matches;
    return {
      cellAlign: "left",
      //contain: !isMobile,  // Allow only one slide per click on mobile
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      groupCells: isMobile ? false : 4  // Slide 1 item on mobile, 4 items on desktop
    };
  }

  function watchForGridItems(relatedProductsSection) {
    const carouselGrid = relatedProductsSection.querySelector(".product-grid");

    if (!carouselGrid) {
      console.log('Carousel grid is missing, retrying...');
      setTimeout(() => watchForGridItems(relatedProductsSection), 100);
      return;
    }

    console.log('Carousel grid found, checking grid items...');

    function pollForGridItems() {
      const gridItems = carouselGrid.querySelectorAll(".grid__item");

      // For mobile: initialize if there is more than 1 item
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      if (isMobile && gridItems.length > 1 || !isMobile && gridItems.length > 4) {
        console.log('Sufficient grid items detected, initializing carousel...');
        initializeCarousel(carouselGrid);
      } else {
        console.log('Not enough grid items yet, retrying...');
        setTimeout(pollForGridItems, 100);
      }
         const recommendations = document.querySelector('product-recommendations');
      if (!recommendations) return;

      const cards = recommendations.querySelectorAll('.product-card-wrapper');

      cards.forEach(card => {
        const varId = card.getAttribute('data-var-id');
        if (varId) {

          alertVariant(varId, "card", "https://roollapius.korres.com");
        }
      });
    }

    pollForGridItems();
  }

  // Throttle function to limit the number of times handleResize is called
  function throttle(fn, wait) {
    let timeout;
    return function (...args) {
      if (!timeout) {
        timeout = setTimeout(() => {
          fn.apply(this, args);
          timeout = null;
        }, wait);
      }
    };
  }

  // Start polling for `product-recommendations` to load
  waitForProductRecommendations();
});
